import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import { RESET_ADMIN_PASSWORD } from "../../../../graphql/mutations/management";
import { FETCH_ADMIN } from "../../../../graphql/queries/management";
import {
  onChangeAdminPasswordForm,
  toggleAdminPasswordModal,
} from "../../redux/adminSlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const AdminPasswordForm = () => {
  const dispatch = useDispatch();
  const { resetPasswordForm } = useSelector((state) => state.admin);

  const [resetAdminPassword, { loading }] = useMutation(RESET_ADMIN_PASSWORD, {
    refetchQueries: [{ query: FETCH_ADMIN }],
    onCompleted: ({ resetAdminPassword }) => {
      if (resetAdminPassword) {
        dispatch(toggleAdminPasswordModal());
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    resetAdminPassword({
      variables: {
        id: resetPasswordForm.id,
        newPassword: resetPasswordForm.newPassword,
      },
    });
  };

  const handleChange = (e) => {
    dispatch(
      onChangeAdminPasswordForm({
        ...resetPasswordForm,
        [e.target.name]: e.target.value,
      })
    );
  };

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ລະຫັດຜ່ານໃໝ່"
        name="newPassword"
        onChange={handleChange}
        type="text"
        value={resetAdminPassword?.newPassword}
        required={true}
      />

      <div className="text-center">
        <SubmitButton loading={loading} />
      </div>
    </Form>
  );
};

export default AdminPasswordForm;
